<template>
  <div class="container-fluid">
    <b-row class="admin-page">
      <div class="col-md-8">
        <div role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle.accordion-1 variant="info">General Settings</b-button>
              <b-button block href="#" v-b-toggle.accordion-2 variant="info">Notifications Settings</b-button>
              <b-button block href="#" v-b-toggle.accordion-3 variant="info">Subfolders</b-button>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-form class="admin-form" @submit.stop.prevent="submitMailbox">
                  <b-form-group horizontal label="Name">
                    <b-form-input type="text" v-model="mailbox.name"></b-form-input>
                  </b-form-group>
                  <b-form-group horizontal label="Gmail Address">
                    <b-form-input type="email" v-model="mailbox.gmail_address"></b-form-input>
                  </b-form-group>
                  <b-form-group horizontal label="Team">
                    <b-form-select type="" v-model="mailbox.team_id" :options="teams"></b-form-select>
                  </b-form-group>
                  <b-form-group horizontal label="Default Board">
                    <b-form-select type="" v-model="mailbox.default_board_id" :options="boards"></b-form-select>
                  </b-form-group>
                  <b-form-group v-if="mailbox.name !== 'Websites'" horizontal label="Disable User Auto Assign">
                    <b-form-checkbox id="disableUserAutoAssign"
                                     v-model="mailbox.disable_user_auto_assign"
                                     value="true"
                                     unchecked-value="false">
                    </b-form-checkbox>
                  </b-form-group>
                  <b-form-group v-if="mailbox.name !== 'Websites'" horizontal label="Sort By Created At">
                    <b-form-checkbox id="sortByCreatedAt"
                                     v-model="mailbox.sort_by_created_at"
                                     value="true"
                                     unchecked-value="false">
                    </b-form-checkbox>
                  </b-form-group>
                  <b-form-group horizontal label="Slack Webhook">
                    <b-form-input type="text" v-model="mailbox.slack_webhook"></b-form-input>
                  </b-form-group>
                  <b-button type="submit" variant="primary">Submit</b-button>
                  <b-button type="reset" variant="warning" @click="resetMailbox(mailbox.id)">Reset</b-button>
                  <b-button type="delete" variant="danger" v-if="mailbox.hasOwnProperty('id')" @click="deleteMailbox(mailbox.id)">Delete</b-button>
                </b-form>
              </b-card-body>
            </b-collapse>
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <MailboxNotificationSettings v-if="mailbox.id" :mailbox=mailbox />
              </b-card-body>
            </b-collapse>
            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-button variant="info" @click="setNewSubfolder()">New Subfolder</b-button>
                <SubfolderForm v-if='showSubfolderForm' :subfolderId="currentSubfolder" :mailbox_id='mailbox.id'/>
                <b-list-group v-if= mailbox.subfolders>
                  <b-list-group-item v-for="subfolder in mailbox.subfolders" href=# @click=setCurrentSubfolder(subfolder.id) :key=subfolder.id>
                    {{subfolder.name}}
                  </b-list-group-item>
                </b-list-group>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
      <div class="col-md-4">
        <div class="google-auth" v-if="mailbox.hasOwnProperty('id')">
          <b-button variant="outline-secondary" target="_blank" :href="authLink">
            <img src="/static/images/google.png">
            Authorize {{mailbox.gmail_address}}
          </b-button>
          <b-form @submit.prevent class="auth-form" inline>
            <b-form-group>
              <b-form-input v-model="authCode" placeholder="Google auth code"></b-form-input>
              <b-button type="submit" variant="primary" @click="submitAuthCode">Submit</b-button>
            </b-form-group>
          </b-form>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {mailboxMixins} from '@/mixins/mailboxMixins'
import MailboxNotificationSettings from '../MailboxNotificationSettings'
import SubfolderForm from '../subfolders/Form'
export default {
  name: 'Mailbox',
  props: ['mailbox', 'mailboxes'],
  mixins: [mailboxMixins],
  data () {
    return {
      teams: [],
      boards: [],
      authLink: '',
      clientId: '',
      authCode: '',
      currentSubfolderId: null,
      newSubfolder: false
    }
  },
  created () {
    this.getTeams()
    this.getClientId()
    this.getBoards()
    this.$root.$on('SUBFOLDER_SUBMIT_SUCCESSFUL', () => {
      this.newSubfolder = false
      this.currentSubfolderId = null
    })
  },
  updated () {
    this.setAuthLink()
  },
  computed: {
    ...mapGetters(['currentUser']),
    currentSubfolder () {
      return this.currentSubfolderId
    },
    showSubfolderForm () {
      if (this.currentSubfolderId || this.newSubfolder) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    MailboxNotificationSettings,
    SubfolderForm
  },
  methods: {
    setCurrentSubfolder (id) {
      this.newSubfolder = false
      this.currentSubfolderId = id
    },

    setNewSubfolder () {
      this.newSubfolder = true
    },
    getBoards () {
      this.$http.get('/boards', { params: { team_id: this.mailbox.team_id } })
        .then(response => this.setBoards(response))
        .catch((e) => this.error(e))
    },

    setBoards (response) {
      this.boards = response.data.map(function (board) {
        return {text: board.name, value: board.id}
      })
    },

    getTeams () {
      this.$http.get('/teams')
        .then(response => this.setTeams(response))
        .catch((e) => this.error(e))
    },

    setTeams (response) {
      this.teams = response.data.map(function (team) {
        return {text: team.name, value: team.id}
      })
    },

    submitMailbox () {
      var mailboxObject = this.mailbox
      if (mailboxObject.hasOwnProperty('id')) {
        this.$http.put(('/mailboxes/' + mailboxObject.id), {mailbox: mailboxObject})
          .then(response => this.submitSuccessful(response))
          .catch((e) => this.error(e))
      } else {
        this.$http.post('/mailboxes', {mailbox: mailboxObject})
          .then(response => this.submitSuccessful(response))
          .catch((e) => this.error(e))
      }
    },

    deleteMailbox (id) {
      this.$http.delete('/mailboxes/' + id)
        .then(response => this.deleteSuccessful(response))
        .catch((e) => this.error(e))
    },

    submitSuccessful (response) {
      this.$emit('submit-successful')
    },

    deleteSuccessful (response) {
      this.$emit('delete-successful')
    },

    setAuthLink (response) {
      var callbackUrl = 'urn:ietf:wg:oauth:2.0:oob'
      var link = 'https://accounts.google.com/o/oauth2/auth?access_type=offline&client_id=' + this.clientId + '&response_type=code&scope=email+profile+https://mail.google.com' + '&redirect_uri=' + callbackUrl
      this.authLink = link
    },

    getClientId () {
      this.$http.get('/client_id')
        .then(response => this.setClientId(response))
        .catch((e) => this.error(e))
    },

    setClientId (response) {
      this.clientId = response.data
      this.setAuthLink()
    },

    submitAuthCode () {
      var authHash = {
        code: this.authCode,
        id: this.mailbox.id
      }
      this.$http.post(('/mailbox_token'), {auth: authHash})
        .then(response => this.tokenSuccess(response))
        .catch((e) => this.error(e))
    },

    tokenSuccess (response) {
      this.authCode = 'success!'
    }
  },
  watch: {
    mailbox: function () {
      this.getBoards()
      this.submitText = 'Submit'
      this.deleteText = 'Delete'
    }
  }
}
</script>

<style>
.google-auth {
  max-width: 300px;
}
.google-auth img {
  max-width: 30px;
}
.auth-form {
  display: block;
  margin-top: 20px;
}
div.col-sm-9 > .custom-checkbox{
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/mailboxes/Show.vue